import { Avatar, Pagination, Table } from "flowbite-react";
import { Link } from "react-router-dom";
import { ScrollableTableWrapper, PaginationInfo } from "../../components";

const columns = [
  "Priority",
  "Account",
  "Contract",
  "Segment",
  "MRR",
  "Expansion Potential",
  "Days until renewal",
  "Stage",
  "Usage Drop",
];

const customerList = [
  {
    id: 1,
    logo: "https://github.com/mohitkyadav.png",
    priority: "1",
    name: "Acme Corp",
    contract: "Contract 1",
    segment: "Enterprise",
    mrr: "$10,000",
    expansionPotential: "$7,000",
    daysUntilRenewal: "30 days",
    stage: "Onboarding",
    usageDrop: -3,
  },
  {
    id: 2,
    logo: "https://github.com/google.png",
    name: "Google",
    priority: "3",
    contract: "Contract 2",
    segment: "Enterprise",
    mrr: "$20,000",
    expansionPotential: "$7,030",
    daysUntilRenewal: "10 days",
    stage: "Onboarding",
    usageDrop: -10,
  },
  {
    id: 2,
    logo: "https://github.com/microsoft.png",
    name: "Microsoft",
    priority: "2",
    contract: "Contract 2",
    segment: "Enterprise",
    mrr: "$20,000",
    expansionPotential: "-$10,000",
    daysUntilRenewal: "10 days",
    stage: "Onboarding",
    usageDrop: -2.7,
  },
];

export const DashboardUsageDropPageTable = () => {
  return (
    <div className="bg-white dark:bg-gray-900">
      <ScrollableTableWrapper height="calc(100vh - 320px)">
        <Table striped hoverable className="drop-shadow-none">
          <Table.Head>
            {columns.map((column, index) => (
              <Table.HeadCell
                key={column}
                className={
                  index === 1
                    ? "sticky left-0 z-20 bg-gray-50 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]"
                    : ""
                }
              >
                {column}
              </Table.HeadCell>
            ))}
          </Table.Head>
          <Table.Body className="divide-y">
            {customerList.map(
              (
                {
                  id,
                  logo,
                  name,
                  priority,
                  contract,
                  segment,
                  mrr,
                  expansionPotential,
                  daysUntilRenewal,
                  stage,
                  usageDrop,
                },
                rowIndex,
              ) => {
                const rowBgColor =
                  rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50";
                return (
                  <Table.Row key={id}>
                    <Table.Cell>
                      <div className="inline-flex h-5 items-center justify-center rounded-lg bg-green-100 px-2 py-0.5">
                        <div className="text-center text-xs font-medium leading-none text-green-900">
                          {priority}
                        </div>
                      </div>
                    </Table.Cell>
                    <Table.Cell
                      className={`sticky left-0 z-10 w-40 ${rowBgColor} shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]`}
                    >
                      <Link
                        className="space-y-1 font-bold hover:text-blue-500 hover:underline"
                        to={`/customers/${id}`}
                      >
                        <Avatar
                          size="xs"
                          img={logo}
                          className="flex justify-start"
                        >
                          {name}
                        </Avatar>
                      </Link>
                    </Table.Cell>
                    <Table.Cell>{contract}</Table.Cell>
                    <Table.Cell>{segment}</Table.Cell>
                    <Table.Cell className="font-bold">{mrr}</Table.Cell>
                    <Table.Cell className="font-bold">
                      {expansionPotential}
                    </Table.Cell>
                    <Table.Cell>{daysUntilRenewal}</Table.Cell>
                    <Table.Cell>{stage}</Table.Cell>
                    <Table.Cell>{usageDrop}</Table.Cell>
                  </Table.Row>
                );
              },
            )}
          </Table.Body>
        </Table>
      </ScrollableTableWrapper>
      <div className="flex w-full items-center justify-between border-t bg-white px-5 py-4 dark:bg-gray-900">
        <PaginationInfo page={1} pageSize={10} total={20} />
        <Pagination
          currentPage={1}
          totalPages={2}
          onPageChange={() => {}}
          showIcons
          previousLabel=""
          nextLabel=""
        />
      </div>
    </div>
  );
};
